import * as React from 'react';

import { generateModifierString } from 'helper/css';
import i18n from 'helper/i18n';

import Bevel from 'components/helper/Bevel';
import { compileDynamicRoute } from 'helper/string';

import Filter from 'components/molecules/Filter';
import { FilterItemType } from 'components/molecules/Filter';

type FavoriteHeaderProps = {
	title: string;
	preselectedCluster?: string;
	modifier?: string | string[];
};

const filterIDs = ['', 'recipe', 'workout', 'tip', 'exercise', 'recommendation'];

const generateFilterItem = (id: string): FilterItemType => {
	let urlPart;
	let label;

	if (id.length > 0) {
		urlPart = i18n(`react.impulsCoach.routes.favorites.cluster.${id}.href`);
		label = i18n(`react.impulsCoach.routes.favorites.cluster.${id}.title`);
	} else {
		urlPart = '';
		label = i18n(`react.impulsCoach.routes.favorites.cluster.all.title`);
	}

	const link = compileDynamicRoute(i18n('react.impulsCoach.routes.favorites.cluster.href'), {
		cluster: urlPart,
	});

	return {
		link,
		label,
		id,
	};
};

const FavoriteHeader = ({ title, modifier, preselectedCluster = '' }: FavoriteHeaderProps) => {
	return (
		<div className={`m-favorite-header ${generateModifierString('m-favorite-header', modifier)}`}>
			<div className="m-favorite-header__bg">
				<Bevel modifier="bottom-left" color="ffffff" />
			</div>

			<div className="container">
				<div className="row">
					<div className="col-xs-12">
						<h1 className="m-favorite-header__title">{title}</h1>
						<Filter selected={preselectedCluster} filters={filterIDs.map(generateFilterItem)} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default FavoriteHeader;
